/** Scroll state of a horizontal container and the layout of one item in it. */
export interface HorizontalRevealParams {
  /** Current horizontal scroll offset of the container. */
  scrollLeft: number;
  /** Visible width of the container. */
  viewportWidth: number;
  /** Item start, measured from the start of the scrolled content. */
  itemLeft: number;
  /** Item width. */
  itemWidth: number;
  /** Space kept between the item and the visible edge. */
  margin?: number;
}

/**
 * Returns the scroll offset that shows an item whole while moving as little
 * as possible. An item that is already visible keeps the current offset.
 *
 * @param params - Container scroll state and item layout.
 * @returns The horizontal scroll offset to apply.
 */
export const getScrollLeftToReveal = ({
  scrollLeft,
  viewportWidth,
  itemLeft,
  itemWidth,
  margin = 0,
}: HorizontalRevealParams): number => {
  const start = itemLeft - margin;
  const end = itemLeft + itemWidth + margin;

  if (start < scrollLeft) return Math.max(0, start);
  if (end > scrollLeft + viewportWidth) return end - viewportWidth;
  return scrollLeft;
};
